<template lang="html">
	<div class="content content-fixed content-auth">
		<div class="container">
			<div class="media align-items-stretch justify-content-center ht-100p pos-relative">
				<div class="media-body align-items-center d-none d-lg-flex">
					<div class="mx-wd-600">
						<img src="../../assets/img/login.png" class="img-fluid" alt="">
					</div>
				</div><!-- media-body -->
				<div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
					<div class="wd-100p">
						<h3 class="tx-color-01 mg-b-5">Sign In</h3>
						<p class="tx-color-03 tx-16 mg-b-40">Welcome back! Please signin to continue.</p>
						<form class="user" @submit.prevent="signin">
							<div class="form-group">
								<label>ID</label>
								<input type="text" v-model="uid" class="form-control" id="exampleInputEmail" placeholder="Enter your ID">
							</div>
							<div class="form-group">
								<div class="d-flex justify-content-between mg-b-5">
									<label class="mg-b-0-f">Password</label>
									<!-- <a href="" class="tx-13">Forgot password?</a> -->
								</div>
								<input type="password" v-model="password" class="form-control" id="exampleInputPassword" placeholder="Password">
							</div>
							<div class="custom-control custom-checkbox small">
								<input type="checkbox" class="custom-control-input" id="customCheck" :checked="checked" @click="checkbox()">
								<label class="custom-control-label" for="customCheck">Remember Me</label>
								<p style="color:red">{{msg}}</p>
							</div>
							<button class="btn btn-brand-02 btn-block">Sign In</button>
						</form>
					</div>
				</div><!-- sign-wrapper -->
			</div><!-- media -->
		</div><!-- container -->
	</div><!-- content -->
	<!-- Outer Row -->
</template>
<script>
	import VueResource from 'vue-resource'
	import crypto from 'crypto-js'
	import Inko from 'inko'
	import { secretKey } from '@/config/config'

	export default {
		name: 'Signin',
		data() {
			return {
				msg: '',
				uid: '',
				password: '',
				checked: false,
			};
		},
		created() {
			if (this.$store.getters.isAuthenticated != undefined) {
				this.$router.push('main');
			}
		},
		mounted() {
			if (localStorage.checkbox && localStorage.checkbox !== '') {
				this.checked = true;
				this.uid = localStorage.userid;
			} else {
				this.checked = false;
				this.uid = '';
			}
		},
		methods: {
			checkbox() {
				if (this.checked) {
					this.checked = false;
				} else {
					this.checked = true;
				}
			},
			signin() {
				if (this.checked) {
					localStorage.userid = this.uid;
					localStorage.checkbox = true;
				} else {
					localStorage.userid = "";
					localStorage.checkbox = "";
				}
				let inko = new Inko();
				const userId = this.uid;
				let password = inko.ko2en(this.password);

				if (!userId) {
					// this.$buefy.dialog.alert({
					// 	message: 'Please enter the ID.',
					// 	size: 'is-medium',
					// 	type: 'is-danger'
					// })
					this.msg = 'Please enter the ID.';
					return false;
				}
				if (!password) {
					// this.$buefy.dialog.alert({
					// 	message: 'Please enter the password.',
					// 	size: 'is-medium',
					// 	type: 'is-danger'
					// })
					this.msg = 'Please enter the password.';
					return false;
				}
				//signin 액션 실행
				password = crypto.AES.encrypt(password, secretKey).toString();
				this.$store.dispatch('SIGNIN', { userId, password })
				.then(() => {
					this.redirect()
				})
				.catch(({ message }) => {
					this.msg = 'ID or password is incorrect';
				})
			},
			notice() {
				alert("준비중 입니다.");
			},
			redirect() {
				const { search } = window.location
				const tokens = search.replace(/^\?/, '').split('&')
				const { returnPath } = tokens.reduce((qs, tkn) => {
					const pair = tkn.split('=')
					qs[pair[0]] = decodeURIComponent(pair[1])
					return qs;
				}, {})
				// 리다이렉트 처리
				if (returnPath == undefined) this.$router.go('main');
				this.$router.go(returnPath);
			}
		}
	};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.btn-lg {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/User/Signin.vue